import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { SERVER_URL } from "../../redux/apiConstants";
import AsyncSelect from 'react-select/async';

function SelectBox({ 
  label,
  name,
  values = [],
  control,
  placeholder,
  labelstyle,
  defaultValue,
  mandatory,
  errors,
  onChange,
  disabled,
  handleLocationChange,
  onLocationSelect
}) {


  const loadOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) {
      return [];
    }

    try {
      const response = await fetch(`${SERVER_URL}/location?location=${encodeURIComponent(inputValue)}`);
      const data = await response.json();
      
      if (data.success) {
        return data.data.map(location => ({
          label: location.description,
          value: {
            description: location.description,
            place_id: location.place_id,
            formatted_address: location.description, // Use description as formatted_address for now
          }
        }));
      }
      return [];
    } catch (error) {
      console.error('Error loading locations:', error);
      return [];
    }
  };

  const fetchPlaceDetails = async (placeId) => {
    try {
      const response = await fetch(`${SERVER_URL}/place-details?placeId=${placeId}`);
      const data = await response.json();
      
      if (data.success) {
        return data.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching place details:', error);
      return null;
    }
  };

  
  const options = values.map((value) => ({
    label: value.formatted_address,
    value: {formatted_address:value.formatted_address,
      location: value?.geometry?.location
    }
  }));
  const colorStyles = {
    control: (defaultStyles) => ({
      ...defaultStyles,
      fontSize: "14px",
      border: "1px solid #ced4da",
      padding: "3px",
      color: "#60677e !important",
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      fontSize: "14px",
      color: "#60677e",
    }),
  };
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: "#151521",
      // match with the menu
      borderRadius: state.isFocused ? "5px" : 5,
      border: "none",
      padding: "3px",
      color: "#60677e !important",
      fontSize: "14px",
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      fontSize: "14px",
      color: "#60677e",
    }),
  };
  let classNamess = colorStyles;

  if (localStorage.getItem("theme") === "dark") {
    classNamess = customStyles;
  } else {
    classNamess = colorStyles;
  }
  const handleKeyDown = (e) => {
    console.log("key down", e);

    if (e.keyCode === 13) {
      const { form } = e.target;
      const index = Array.prototype.indexOf.call(form, e.target);
      form.elements[index + 1].focus();
      e.preventDefault();
    }
  };

  const handleInputChange = (e) => {
    console.log("key down", e);
    handleLocationChange(e);
  };
  return (
    <div>
      <label className={labelstyle} htmlFor={name}>
        {label ?? "SelectBox"}
      </label>
      {mandatory ? (
        <span style={{ color: "red", marginLeft: "3px" }}>*</span>
      ) : (
        <span />
      )}
     <Controller
        name={name}
        control={control}
        rules={mandatory ? {
          required: {
            value: true,
            message: `${label} is required`,
          },
        } : {}}
        render={({ field: { value, onChange, onBlur } }) => (
          <AsyncSelect
            styles={classNamess}
            loadOptions={loadOptions}
            defaultOptions={[]}
            onInputChange={(inputValue) => {
              handleLocationChange(inputValue);
            }}
            placeholder={placeholder ?? "Search location..."}
            onChange={async (selectedOption) => {
              if (selectedOption) {
                // Get full place details with coordinates
                const placeDetails = await fetchPlaceDetails(selectedOption.value.place_id);
                
                if (placeDetails) {
                  const locationData = {
                    formatted_address: placeDetails.formatted_address,
                    location: placeDetails.geometry.location, // This contains lat and lng
                    place_id: placeDetails.place_id,
                    name: placeDetails.name
                  };
                  
                  console.log("Selected location with coordinates:", locationData);
                  onChange(locationData); // Pass the complete location data to form
                  
                  // Notify parent component if needed
                  if (onLocationSelect) {
                    onLocationSelect(locationData);
                  }
                }
              } else {
                onChange(null);
              }
            }}
            onBlur={onBlur}
            value={value ? { 
              label: value.formatted_address || value.description, 
              value: value 
            } : null}
            isClearable
            isDisabled={disabled}
            loadingMessage={() => "Searching locations..."}
            noOptionsMessage={({ inputValue }) => 
              inputValue.length < 3 ? "Type at least 3 characters..." : "No locations found"
            }
          />
        )}
      />
      <p
        style={{
          color: "red",
          marginTop: "5px",
          fontSize: "14px",
          fontFamily: "SFUIDisplayRegular",
        }}
      >
        {" "}
        {
          // Shows if error exist
          errors[name] && errors[name].message
        }{" "}
      </p>
    </div>
  );
}

SelectBox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  values: PropTypes.oneOfType([PropTypes.array]).isRequired,
  control: PropTypes.oneOfType([PropTypes.object]).isRequired,
  placeholder: PropTypes.string,
  labelstyle: PropTypes.string.isRequired,
  mandatory: PropTypes.bool,
  defaultvalue: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onChange: PropTypes.func,
};

SelectBox.defaultProps = {
  defaultvalue: "0",
  label: "SelectBox",
  placeholder: "Please Select",
  mandatory: false,
};

SelectBox.defaultValue = {
  mandatory: false,
};

export default SelectBox;
